import { callFunction } from './functionsClient';
import type {
  GameSummary,
  SlotResult,
  RouletteResult,
  BlackjackView,
  BlackjackResult,
} from '../types';

export type RouletteBetType =
  | 'straight'
  | 'red'
  | 'black'
  | 'even'
  | 'odd'
  | 'low'
  | 'high'
  | 'dozen'
  | 'column';

export type BlackjackAction = 'hit' | 'stand' | 'double' | 'split' | 'insurance';

export const gamesApi = {
  listGames: () => callFunction<{ games: GameSummary[] }>('list-games'),

  playSlot: (betAmount: number) =>
    callFunction<SlotResult>('play-slot', {
      method: 'POST',
      body: { betAmount },
    }),

  playRoulette: (
    betAmount: number,
    betType: RouletteBetType,
    betValue?: number,
  ) =>
    callFunction<RouletteResult>('play-roulette', {
      method: 'POST',
      body: { betAmount, betType, betValue },
    }),

  blackjackDeal: (betAmount: number) =>
    callFunction<{ roundId: string; view: BlackjackView; balanceAfter: number }>(
      'blackjack-deal',
      { method: 'POST', body: { betAmount } },
    ),

  blackjackAction: (roundId: string, action: BlackjackAction) =>
    callFunction<{
      roundState: BlackjackView;
      result: BlackjackResult | null;
      balanceAfter: number;
    }>('blackjack-action', {
      method: 'POST',
      body: { roundId, action },
    }),
};
